<template>
  <section>
    <div class="editor-content">
      <iframe ref="iframe" scrolling="no" :src="editor" style="display:1; height: 93%; width:90%; position:absolute;">
      </iframe>
    </div>
  </section>
</template>

<script>
  export default {
    data () {
      return {
        windowHeight: window.innerHeight,
        transcription: null,
        transcriptionName: '',
        mediaPath: '',
        wavePath: '',
        savePath: '',
        preferencesPath: '',
        propertiesPath: '',
        duration: 0,
        editor: null,
        exportAudioPath: '',
        exportHtmlPath: ''
      };
    },
    async created () {
      window.parent.transcriptionFunction = this.transcriptionFunction;
      window.parent.audioUrlFunction = this.audioUrlFunction;
      window.parent.durationFunction = this.durationFunction;
      window.parent.saveFunction = this.saveFunction;

      window.parent.propertiesFunction = this.propertiesFunction;
      window.parent.savePropertiesFunction = this.savePropertiesFunction;

      window.parent.savePreferencesFunction = this.savePreferencesFunction;
      window.parent.preferencesFunction = this.preferencesFunction;

      window.parent.closeWindowEditorFunction = this.closeWindowEditorFunction;
      window.parent.wavePathFunction = this.wavePathFunction;

      window.parent.exportAudio = this.exportAudio;
      window.parent.exportHtml = this.exportHtml;
      window.parent.autoSpeakersFunction = this.autoSpeakersFunction;
      window.parent.updateSpeakersFunction = this.updateSpeakersFunction;

      this.transcription = this.$route.params.transcription;
      this.transcriptionName = this.$route.params.name;
      this.duration = this.$route.params.duration;
      this.autoSpeakers = this.$route.params.autoSpeakers;
      this.mediaPath = this.$route.params.mediaPath;
      this.wavePath = this.$route.params.wavePath;
      this.savePath = this.$route.params.savePath;
      this.preferencesPath = this.$route.params.preferencesPath;
      this.propertiesPath = this.$route.params.propertiesPath;
      this.exportAudioPath = this.$route.params.exportAudioPath;
      this.exportHtmlPath = this.$route.params.exportHtmlPath;
      this.updateSpeakersPath = this.$route.params.updateSpeakersPath;

      window.parent.transcriptionName = this.transcriptionName;
    },
    computed: {
      filterSectionHeight () {
        return this.windowHeight;
      }
    },
    mounted () {
      this.editor = '/editor/';
    },
    methods: {
      transcriptionFunction () {
        return JSON.stringify(this.transcription);
      },
      audioUrlFunction () {
        return this.mediaPath;
      },
      durationFunction () {
        return this.duration;
      },
      wavePathFunction () {
        return this.wavePath;
      },
      autoSpeakersFunction () {
        return this.autoSpeakers;
      },
      propertiesFunction () {
        const editChannels = (this.transcription.channels) ? this.transcription.channels.slice() : [];
        const oldChannels = [];
        if (editChannels.length > 0) {
          for (let index = 0; index < this.transcription.channels.length; index++) {
            const element = this.transcription.channels[index];
            oldChannels.push({ _id: element._id, name: element.name });
          }
        }
        return { name: this.transcriptionName, oldChannels, editChannels };
      },
      async savePropertiesFunction (editedProperties) {
        const requestMetadataOptions = {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ name: editedProperties.name, description: '' })
        };
        let res = await fetch(this.propertiesPath, requestMetadataOptions);
        if (res.status === 200) {
          if (editedProperties.transcription) {
            const requestChannelsOptions = {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ transcription: editedProperties.transcription })
            };
            res = await fetch(this.savePath, requestChannelsOptions);
            if (res.status === 200) {
              this.$toast.open('Dados alterados com sucesso!');
            } else {
              this.$toast.open({ message: 'Não foi possível atualizar!', type: 'error' });
              console.log(res.error);
              return false;
            };
          } else {
            this.$toast.open('Dados alterados com sucesso!');
          }
          this.$emit('updateTranscriptionName', this.name);
          this.$emit('updateTranscriptionChannels', this.transcription);
          return true;
        } else {
          this.$toast.open({ message: 'Não foi possível atualizar!', type: 'error' });
          console.log(res.error);
          return false;
        }
      },
      async savePreferencesFunction (payload) {
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        };
        const res = await fetch(this.preferencesPath, requestOptions);
        if (res.status === 200) {
          this.$toast.open('Dados salvos com sucesso!');
        } else {
          this.$toast.open({ message: 'Não foi possível salvar as preferências!', type: 'error' });
          console.log(res.error);
        }
      },
      async preferencesFunction () {
        const requestOptions = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        };
        const result = await fetch(this.preferencesPath, requestOptions);
        if (result.status === 200) {
          return await result.json();
        } else {
          return {};
        }
      },
      async saveFunction (transcript, context) {
        const transcription = JSON.parse(transcript);
        const requestOptions = {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ transcription: transcription })
        };
        await fetch(this.savePath, requestOptions);
      },
      async updateSpeakersFunction (speakers) {
        const requestOptions = {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ speakers: speakers })
        };
        await fetch(this.updateSpeakersPath, requestOptions);
      },
      closeWindowEditorFunction () {
        console.log('close');
      },
      stopAudio () {
        this.$refs.iframe.contentWindow.postMessage('close-editor', '*');
      },
      async exportAudio (outputFormat) {
        const formData = JSON.stringify({ outputFormat });
        const convertedAudio = await fetch(this.exportAudioPath, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: formData
        })
          .then(response => response.blob())
          .catch(error => console.error('Erro:', error));
        return convertedAudio;
      },
      async exportHtml () {
        const htmlProject = await fetch(this.exportHtmlPath)
          .then(response => response.blob())
          .catch(error => console.error('Erro:', error));
        return htmlProject;
      }
    }
  };
</script>

<style>
.editor-content {
  margin-top: 70px;
}
</style>
